import PropTypes from 'prop-types';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';

/**
 * @param root0
 * @param root0.trigger
 * @param root0.triggerClass
 * @param root0.content
 * @param root0.contentClass
 * @param root0.asChild
 * @param root0.delayDuration
 * @returns {JSX} TooltipHelper
 */
function TooltipHelper({ trigger, triggerClass, content, contentClass, delayDuration = 300, asChild = false }) {
    return (
        <Tooltip delayDuration={delayDuration}>
            <TooltipTrigger className={triggerClass} asChild={asChild}>
                {
                    trigger
                }
            </TooltipTrigger>
            <TooltipContent className={contentClass}>
                {
                    content
                }
            </TooltipContent>
        </Tooltip>
    );
}

TooltipHelper.propTypes = {
    trigger: PropTypes.element.isRequired,
    triggerClass: PropTypes.string,
    content: PropTypes.node.isRequired,
    contentClass: PropTypes.string,
    asChild: PropTypes.bool,
    delayDuration: PropTypes.number
};

export default TooltipHelper;